(function () {
    'use strict';
    realmCommerceApp.config(config);

    /*@ngInject*/
    function config(FacebookProvider) {
        // Set your appId through the setAppId method or
        // use the shortcut in the initialize method directly.
        FacebookProvider.init('645764028930352');
    }

})();



// WEBPACK FOOTER //
// ./static/js/app/config/facebook.config.js